import React from "react";
import { Divider, List, useMediaQuery, useTheme } from "@mui/material";
import { SideBarItem } from "./SideBarItem";
import { NavItem } from "../../types/navTypes";
import { StyledDrawer, ToolbarSpacer } from "./SideBar.styles";
import { useAuth } from "../../../../app/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

interface SideBarProps {
  items: NavItem[];
  isOpen: boolean;
  toggle: () => void;
  onItemClick?: (path: string) => void;
}

export const SideBar: React.FC<SideBarProps> = ({
  items,
  isOpen,
  toggle,
  onItemClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { logout } = useAuth();
  const navigate = useNavigate();

  const isAdmin = React.useMemo(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        return parsedUser?.admin === true;
      } catch (e) {
        console.warn("Erro ao fazer parse do userData:", e);
      }
    }
    return false;
  }, []);

  const handleItemClick = async (item: NavItem) => {
    if (isMobile) toggle();

    if (item.isModal) {
      onItemClick?.("abrirModalAssinatura");
    } else if (item.isLogout) {
      await logout();
      navigate("/", { replace: true });
    } else if (item.path) {
      onItemClick?.(item.path);
    }
  };

  return (
    <StyledDrawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isOpen}
      customOpen={isOpen}
      onClose={toggle}
      ModalProps={{ keepMounted: true }}
    >
      <ToolbarSpacer />
      <Divider />
      <List>
      {items.map(
  (item, index) =>
    !(item.adminOnly && !isAdmin) && ( 
      <SideBarItem
        key={index}
        item={item}
        isSideBarOpen={isOpen}
        onClick={() => handleItemClick(item)}
      />
    )
)}
      </List>
    </StyledDrawer>
  );
};
